/**
 * @title browse.js: Feature level module
 * @description The module used for the 'browse'
 * feature which encapsulates 'home','search',
 * 'product details', etc.
 * @dependency header.js, navigation.js
 */

define(['carousel','search','compareProducts','cashcard','extendedAddToCart','quickView','swatches','sogicaReferral','costcoWallet'], function(carousel,search,compareProducts,cashcard,extendedAddToCart,quickView,swatches,costcoWallet) {

	function init() {
		carousel.init();
		search.init();
		COSTCO.util.safe(COSTCO.util.display_member_prices)
			.call(COSTCO.util);
		compareProducts.init();
		cashcard.init();	
		extendedAddToCart.init();
		COSTCO.Search.forceAriaAttributes();
		COSTCO.dialog.initializeReturnFocusListener();
		COSTCO.sogicaReferral.init();
	}
	
	if(typeof window.COSTCO == 'undefined'){
		window.COSTCO = new Object();
	}
	
	if(typeof window.COSTCO.Global == 'undefined')
		document.addEventListener("CostcoGlobalLoaded", init, false);
	else{
		init();
	}
	
});


// WEBPACK FOOTER //
// ./js/browse/browse.js